import { useNavigate } from "react-router-dom";
import GridView from "../../components/controls/GridView/GridView";
import accountTypeService, {
  AccountType,
} from "../../services/accountTypeService";
import "./account-type-listing.module.css";
import { useEffect, useState } from "react";
import { MenuItem } from "../../models/menu";
import FormModal from "../../components/controls/FormModal/FormModal";
import FormCommand from "../../components/controls/FormCommand";
import { AccountCacheService } from "../../services/accountService";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import Frame from "../../components/controls/Frame/Frame";
import CheckBox from "../../components/controls/Checkbox/CheckBox";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";
import { Column, Row } from "../../components/controls/Layout/Layout";

export interface AccountTypeListingPageProps {
  isModal?: boolean;
}

export const AccountTypeListingPage = (props: AccountTypeListingPageProps) => {
  const navigate = useNavigate();
  const [accountTypes, setAccountTypes] = useState<AccountType[]>([]);
  const [accountType, setAccountType] = useState<AccountType>();
  const [searchText, setSearchtext] = useState("");

  const accountTypeMenu: MenuItem<AccountType>[] = [
    new MenuItem("Set Transaction types", (e: AccountType) =>
      alert("setting account type transaction types")
    ),
    new MenuItem("Delete", (e: AccountType) => {
      const ans = window.confirm(
        "Are you sure you want to delete account type\n" + e.name
      );
      if (ans) {
        const deleteAccountType = async () => {
          const res = await accountTypeService.deleteAccountType(e.id ?? 0);
          if (res.status) {
            alert(res.message);

            setAccountTypes(accountTypes.filter((d) => d.id !== e.id));
            return;
          }

          alert(res.message);
        };

        deleteAccountType();
      }
    }),
    new MenuItem("Edit", (e: AccountType) => {
      setAccountType(accountType);
    }),
  ];

  const getAccountsTypes = async (text: string) => {
    const resp = await accountTypeService.getAccountTypes({
      pageNo: 1,
      pageSize: 10,
      name: searchText,
    });

    if (resp?.status) {
      setAccountTypes(accountTypes);
    }
  };

  const saveAccountType = async () => {
    if (accountType !== undefined) {
      const resp = await accountTypeService.createOrUpdateAccountType(
        accountType
      );
      if (resp.status) {
        alert(resp.message);
        setAccountType(undefined); // Will also hide the modal
        return;
      }

      alert(resp.message);
    }
  };

  useEffect(() => {
    getAccountsTypes("");
  }, []);

  return (
    <div className="row">
      <div className="col">
        <Frame>
          <h4>Type of Account(s)</h4>
          <GridView
            showSearchBar={true}
            context="Account Type"
            name={"lst_account_types"}
            showAddButton={true}
            rowsPerPage={50}
            onAddRecord={() => setAccountType({})}
          >
            <GridView.Header>
              <thead>
                <tr>
                  <th>Account Type Name</th>
                  <th>Account Group</th>
                  <th>Action(s)</th>
                </tr>
              </thead>
            </GridView.Header>
            <GridView.Footer>
              {accountTypes.map((d) => (
                <tr>
                  <td>{d.name}</td>
                  <td> {d.accountGroupName}</td>
                  <td>
                    <ContextMenu menu={accountTypeMenu} item={d} />
                  </td>
                </tr>
              ))}
            </GridView.Footer>
          </GridView>

          {accountType && (
            <FormModal onClose={() => setAccountType(undefined)}>
              <AccountTypeForm />
            </FormModal>
          )}
        </Frame>
      </div>
    </div>
  );
};

export function AccountTypeForm() {
  const [accountType, setAccountType] = useState<AccountType>({});
  const accountCacheService = new AccountCacheService();

  return (
    <div className="row">
      <div className="col-8">
        <h3>Account Type</h3>
        <div className="row">
          <div className="col-7">
            <div className="form-group">
              <label htmlFor="accountTypeName" className="control-label">
                Account Type Name
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name of Product/AccountType"
                value={accountType.name}
                onChange={(e) =>
                  setAccountType({
                    ...accountType,
                    name: e.currentTarget.value,
                  })
                }
              />
            </div>
          </div>
          <div className="col-5">
            <div className="form-group">
              <label htmlFor="accountGroup" className="control-label">
                Account Group
              </label>
              <select
                className="form-control"
                name="accountGroup"
                id="accountGroup"
                onChange={(e) =>
                  setAccountType({
                    ...accountType,
                    accountGroupId: Number(e.currentTarget.value),
                  })
                }
                value={accountType.accountGroupId}
              >
                <option>Select Account Group</option>
                {accountCacheService.getAccountGroups().map((d) => {
                  return <option value={d.id}>{d.name}</option>;
                })}
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <CheckBox
              id="enableSMSAlert"
              text="Enable SMS Alert"
              onChecked={(value) =>
                setAccountType({ ...accountType, enableSMSAlert: value })
              }
            />
          </div>
          <div className="col">
            <CheckBox
              id="enableEmailAlert"
              text="Enable Email Alert"
              onChecked={(value) =>
                setAccountType({ ...accountType, enableEmailAlert: value })
              }
            />
          </div>
        </div>

        <FindAccount
          text="SMS Income Account"
          id="smsIncomeAccountId"
          onAccountSelected={(account) =>
            setAccountType({ ...accountType, smsIncomeAccountId: account.id })
          }
        />

        <FindAccount
          text="SMS Expense Account"
          id="smsExpenseAccountId"
          onAccountSelected={(account) =>
            setAccountType({ ...accountType, smsExpenseAccountId: account.id })
          }
        />

        <FindAccount
          text="Interest Income Account"
          id="interestIncomeAccountId"
          onAccountSelected={(account) =>
            setAccountType({
              ...accountType,
              interestIncomeAccountId: account.id,
            })
          }
        />

        <FindAccount
          text="Interest Expense Account"
          id="interestExpenseAccountId"
          onAccountSelected={(account) =>
            setAccountType({
              ...accountType,
              interestExpenseAccountId: account.id,
            })
          }
        />

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label htmlFor="minimumBalance" className="control-label">
                Minimum Balance
              </label>
              <input
                type="number"
                name="minimumBalance"
                id="minimumBalance"
                className="form-control"
                value={accountType.minimumBalance}
                onChange={(e) =>
                  setAccountType({
                    ...accountType,
                    minimumBalance: Number(e.currentTarget.value),
                  })
                }
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="smsSenderId" className="control-label">
                SMS SenderID
              </label>
              <input
                type="text"
                name="smsSenderId"
                id="smsSenderId"
                className="form-control"
                value={accountType.smsSenderId}
                onChange={(e) =>
                  setAccountType({
                    ...accountType,
                    name: e.currentTarget.value,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className="form-group">
          <CheckBox
            id="sendAccountOpeningMessage"
            text="Send Account Opening Message"
            onChecked={(value) =>
              setAccountType({
                ...accountType,
                sendAccountOpeningMessage: value,
              })
            }
            checked={accountType.sendAccountOpeningMessage}
          />

          <CheckBox
            id="allowDebitBalance"
            text="Allow Debit Balance"
            onChecked={(value) =>
              setAccountType({ ...accountType, allowDebitBalance: value })
            }
            checked={accountType.allowDebitBalance}
          />
        </div>

        <FormCommand
          commandText="Save changes"
          onSubmit={() => {
            //saveAccountType();
          }}
        />
      </div>
    </div>
  );
}
